<template>
  <section class="bg-gradient-to-br from-cyan-50 via-white to-cyan-100">
    <NavBody bg="bg-gradient-to-br from-cyan-50 via-white to-cyan-100">
      <template #body>
        <p class="font-bold text-2xl text-brand-primary">{{ userDetails.name.split(' ')[0] }}, let’s see how your referrals are doing</p>
        <p class="font-normal text-base text-[#8C94A6]">Have a beautiful {{ greeting }}!</p>
      </template>
    </NavBody>
    <div class="mx-auto lg:max-w-[80rem] z-20 gap-6 w-full px-4 lg:px-0 bg-gradient-to-br from-cyan-50 via-white to-cyan-100 mt-40">
      <br />
      <br />
      <div class="scrollbar-hide">
        <div class="rounded-xl p-5 lg:px-6 lg:py-8">
          <div class="mb-8">
            <ReferrerStat :summary="summaryAnalytics" :referLevel="referLevel" />
          </div>

          <div>
            <h2 class="text-xl font-semibold mb-3">Your Referral Pipeline</h2>
            <referral-card v-for="item in referrals" :key="item?.uuid" :referral="item" />
          </div>

          <Paginate
            v-if="pageLoaded"
            :from="paginateContent?.meta?.from"
            :to="paginateContent?.meta?.to"
            :total="paginateContent?.meta?.total"
            :current="paginateContent?.meta?.current_page"
            :next="paginateContent?.links?.next"
            :prev="paginateContent?.links?.prev"
            :pages="paginateContent?.meta?.links"
            @move="doPaginate"
          />
        </div>

        <div class="rank-card mt-6">
          <rank-card />
        </div>

        <!-- refer link -->
        <div class="my-6 grid md:grid-cols-2 gap-6" v-if="pageLoaded">
          <div class="px-6 py-8 bg-white rounded-[10px] border border-[#F3F4F6] flex flex-col justify-between">
            <div class="mb-6">
              <p class="text-2xl font-albert text-brand-primary">Active Referrals</p>
              <p class="text-base text-[#8C94A6]">Here is a list of everyone you have referred on the platform</p>
            </div>
            <div v-if="summaryCount.all > 0" class="bg-[#FEFAF1] py-8 px-5 flex items-center justify-between rounded-[20px]">
              <div>
                <p>You have referred {{ summaryCount.all }} people</p>
                <div class="flex -space-x-4 rtl:space-x-reverse">
                  <img
                    v-for="i in summaryCount.all"
                    :key="i"
                    class="w-10 h-10 border-2 border-white rounded-full"
                    src="@/assets/images/whiteAva.svg"
                    alt=""
                  />
                  <a
                    v-if="summaryCount.all > 9"
                    class="flex items-center justify-center w-10 h-10 text-xs font-medium text-black bg-gray-200 border-2 border-white rounded-full"
                    href="#"
                    >+{{ summaryCount.all - 9 }}</a
                  >
                </div>
              </div>
            </div>
            <div v-else class="bg-[#FEFAF1] py-8 px-5 flex items-center justify-between rounded-[20px]">
              <div>
                <div class="flex -space-x-4 rtl:space-x-reverse">
                  <img class="w-10 h-10 rounded-full" src="@/assets/images/whiteAva.svg" alt="" />
                  <img class="w-10 h-10 rounded-full" src="@/assets/images/girlAva.svg" alt="" />
                  <img class="w-10 h-10 rounded-full" src="@/assets/images/Avatar.svg" alt="" />
                  <img class="w-10 h-10 rounded-full" src="@/assets/images/girlAva.svg" alt="" />
                  <img class="w-10 h-10 rounded-full" src="@/assets/images/whiteAva.svg" alt="" />
                  <img class="w-10 h-10 rounded-full" src="@/assets/images/Avatar.svg" alt="" />
                </div>
              </div>
              <p class="font-albertSemiBold text-sm">Sorry, you have not referred anyone at the moment</p>
            </div>
          </div>
          <div class="px-6 py-8 bg-white rounded-[10px] border border-[#F3F4F6]">
            <p class="mb-8 text-2xl font-albertSemiBold">Refer your network to join CareerBuddy</p>
            <div class="bg-[#FBE9F2] rounded-[20px] pl-6 flex items-center justify-between">
              <div class="py-6 w-[40%]">
                <p class="mb-4 font-albertSemiBold text-brand-primary">
                  Get your own referral link and invite your fellow recruiter to join careerbuddy
                </p>
                <button @click="copyReferral" class="px-3 py-2 bg-brand-primary rounded-[10px] text-white flex items-center gap-x-2">
                  Copy Referral Link <Copy />
                </button>
              </div>
              <div class="relative">
                <img src="@/assets/images/circleBackgrounds.svg" alt="" class="" />
                <img src="@/assets/images/refer.svg" alt="" class="absolute top-2 right-[18px]" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading :is-loading="!pageLoaded" className="flex justify-center" />
    </div>
  </section>

  <Summary :open="showSummary" :summary="summaryAnalytics" :referLevel="referLevel" @on-close="showSummary = false" />

  <Detail
    v-if="showRefDetail"
    :open="showRefDetail"
    :refId="selectedRefId"
    @on-close="
      selectedRefId = null;
      showRefDetail = fals;
    "
  />
</template>

<script setup>
import Card from '@/components/jobCard.vue';
import NavBody from '@/components/NavBody.vue';
import Paginate from '@/components/PaginateAlt.vue';
import { ref, computed, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { errorMessage, alert, calcPercent } from '@/utils/helper';
import Loading from '@/components/Loading.vue';
import * as moment from 'moment';
import Summary from '@/components/referrals/Summary.vue';
import Detail from '@/components/referrals/Detail.vue';
import ReferralCard from '@/components/referrals/ReferralCard.vue';
import RankCard from '@/components/referrals/RankCard..vue';
import ReferrerStat from '@/components/referrals/ReferrerStat.vue';
// import Calendar from '@/assets/icons/calendarRefer.svg?inline';
// import Filter from '@/assets/icons/referFilter.svg?inline';

const store = useStore();
const router = useRouter();

const pageLoaded = ref(false);
const loading = ref(false);
const showSummary = ref(false);
const currentPage = ref(1);
const referrals = ref([]);
const selectedRefId = ref(null);
const showRefDetail = ref(false);
const summaryAnalytics = ref({
  admin_shortlisted: 0,
  all: 0,
  client_review: 0,
  client_shortlsted: 0,
  hired: 0,
});

const tableHead = ref(['Candidate', 'Company', 'Job Title', 'Referral Status', 'Application Status', 'Created Date']);

const userDetails = computed(() => store.getters['auth/userDetails']);
const summaryCount = computed(() => store.getters['global/getReferralCount']);
const paginateContent = computed(() => store.getters['global/getAllReferrals']);

const summary = computed(() => {
  const sumCount = store.getters['global/getReferralCount'];
  return [
    {
      title: 'All Candidates',
      count: sumCount.all,
    },
    {
      title: 'Shortlisted Candidates',
      count: sumCount.shortlisted,
    },
    {
      title: 'Interviewed Candidates',
      count: sumCount.interviewed,
    },
    {
      title: 'Hired Candidates',
      count: sumCount.hired,
    },
    {
      title: 'Rejected Candidates',
      count: sumCount.rejected,
    },
  ];
});

const referLevel = computed(() => {
  const shortlisted = calcPercent(summaryAnalytics.value?.client_shortlsted, summaryAnalytics.value?.all);
  if (shortlisted >= 70) {
    return {
      label: 'Platinum',
      color: 'platinum',
      ring: 'ring-purple-500',
      percent: shortlisted,
    };
  } else if (shortlisted >= 50 && shortlisted <= 69) {
    return {
      label: 'Gold',
      color: 'gold',
      ring: 'ring-yellow-500',
      percent: shortlisted,
    };
  } else if (shortlisted >= 30 && shortlisted <= 49) {
    return {
      label: 'Silver',
      color: 'silver',
      ring: 'ring-gray-500',
      percent: shortlisted,
    };
  } else {
    return {
      label: 'Bronze',
      color: 'bronze',
      ring: 'ring-yellow-600',
      percent: shortlisted,
    };
  }
});

const greeting = computed(() => {
  const currentHour = new Date().getHours();

  if (currentHour < 12) {
    return 'Morning';
  } else if (currentHour < 18) {
    return 'Afternoon';
  } else {
    return 'Evening';
  }
});

const doPaginate = async ({ params }) => {
  currentPage.value = params.get('page');
  await getAllReferrals();
};

const copyReferral = () => {
  navigator.clipboard
    .writeText(
      `https://candidate.thecareerbuddy.com/register?referralId=${userDetails.value.uuid}
`,
    )
    .then(() => {
      alert('Text copied to clipboard!');
    })
    .catch((err) => {
      console.error('Failed to copy text: ', err);
    });
};

const getAllReferrals = async () => {
  referrals.value = await store.dispatch('global/getAllReferrals', { page: currentPage.value });
};

const getReferralSummary = async () => {
  try {
    loading.value = true;
    summaryAnalytics.value = await store.dispatch('global/getReferralSummary');
  } catch (error) {
    alert(errorMessage(error), 'error');
  } finally {
    loading.value = false;
  }
};

onBeforeMount(async () => {
  await store.dispatch('global/referralCount');
  await Promise.all([getAllReferrals(), getReferralSummary()]);
  pageLoaded.value = true;
});
</script>
